module.exports = __webpack_public_path__ + "img/c-thermometer-img7-2.81d26d61.jpg";